(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-with-tabs"] && !Shopify.designMode) return;
  try {
    
  function initCollectionsWithTabs(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.tabsInitialized === 'true') {
      return;
    }

    sectionRoot.dataset.tabsInitialized = 'true';

    const tabs = Array.from(sectionRoot.querySelectorAll('[data-tab-target]'));
    const panels = Array.from(sectionRoot.querySelectorAll('[data-tab-panel]'));
    const links = Array.from(sectionRoot.querySelectorAll('[data-tab-link]'));
    const tabsContainer = sectionRoot.querySelector('.collections-with-tabs__tabs');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sliderReady =
      typeof window.customElements === 'undefined'
        ? Promise.resolve()
        : window.customElements.whenDefined('theme-carousel');

    const hydratePanel = (panel) => {
      if (!panel || panel.dataset.tabLoaded === 'true') {
        return false;
      }

      const template = panel.querySelector(':scope > template[data-tab-panel-template]');
      if (!template) {
        return false;
      }

      template.replaceWith(template.content.cloneNode(true));
      panel.dataset.tabLoaded = 'true';
      window.productItemVideoReveal?.init(panel);
      return true;
    };

    // 通过 Section Rendering API 一次性拉取整段 HTML，提取各面板的 <template> 回填；共享 Promise 防止并发重复请求
    let panelsFetchPromise = null;
    let panelsPrefetchObserver = null;
    const stopObservingPanels = () => {
      panelsPrefetchObserver?.disconnect();
      panelsPrefetchObserver = null;
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    };
    const onSectionUnload = (event) => {
      if (event.target.contains(sectionRoot)) {
        stopObservingPanels();
      }
    };
    const fetchAllPanels = () => {
      if (!panelsFetchPromise) {
        stopObservingPanels();
        panelsFetchPromise = fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionRoot.dataset.collectionsWithTabsId), {
          credentials: 'same-origin'
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Section request failed: ' + response.status);
            }
            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            panels.forEach((panel) => {
              if (panel.dataset.tabLoaded === 'true') {
                return;
              }
              if (panel.querySelector(':scope > template[data-tab-panel-template]')) {
                return;
              }
              const remotePanel = doc.querySelector('[data-tab-panel="' + panel.dataset.tabPanel + '"]');
              if (!remotePanel) {
                return;
              }
              const remoteTemplate = remotePanel.querySelector(':scope > template[data-tab-panel-template]');
              const remoteHtml = remoteTemplate ? remoteTemplate.innerHTML : remotePanel.innerHTML;
              if (!remoteHtml || !remoteHtml.trim()) {
                return;
              }
              const tpl = document.createElement('template');
              tpl.setAttribute('data-tab-panel-template', '');
              tpl.innerHTML = remoteHtml;
              panel.appendChild(tpl);
            });
          })
          .catch((error) => {
            // 失败后重置 Promise，下次切换 tab 可重试
            panelsFetchPromise = null;
            console.error('collections-with-tabs: failed to load tab panels', error);
          });
      }
      return panelsFetchPromise;
    };

    const ensurePanelLoaded = (panel) => {
      if (!panel || panel.dataset.tabLoaded === 'true') {
        return Promise.resolve();
      }
      if (hydratePanel(panel)) {
        return Promise.resolve();
      }
      panel.setAttribute('aria-busy', 'true');
      return fetchAllPanels().then(() => {
        hydratePanel(panel);
        panel.removeAttribute('aria-busy');
      });
    };

    const scrollTabIntoView = (tab) => {
      if (!tab || !tabsContainer) {
        return;
      }

      const tabLeft = tab.offsetLeft;
      const tabRight = tabLeft + tab.offsetWidth;
      const visibleLeft = tabsContainer.scrollLeft;
      const visibleRight = visibleLeft + tabsContainer.clientWidth;

      if (tabLeft >= visibleLeft && tabRight <= visibleRight) {
        return;
      }

      const targetLeft = tabLeft - (tabsContainer.clientWidth - tab.offsetWidth) / 2;
      tabsContainer.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    };

    const activateTab = (tabId) => {
      let activeTab = null;
      let activePanel = null;
      let activeLink = null;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.tabTarget === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');

        if (isActive) {
          activeTab = tab;
        }
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === tabId;
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          activePanel = panel;
          panel.removeAttribute('hidden');
          ensurePanelLoaded(panel).then(() => {
            const rail = panel.querySelector('.collections-with-tabs__slider');

            if (rail) {
              sliderReady.then(() => {
                if (typeof rail.activate === 'function') {
                  rail.activate({ reset: true });
                }
              });
            }
          });
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      links.forEach((link) => {
        const isActive = link.dataset.tabLink === tabId;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          activeLink = link;
        }
      });

      if (!prefersReducedMotion && activePanel) {
        activePanel.animate(
          [
            { opacity: 0, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          {
            duration: 260,
            easing: 'ease-out'
          }
        );
      }

      if (!prefersReducedMotion && activeLink) {
        activeLink.animate(
          [
            { opacity: 0, transform: 'translateY(8px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          {
            duration: 240,
            easing: 'ease-out'
          }
        );
      }

      scrollTabIntoView(activeTab);
    };

    const focusTabByOffset = (currentTab, offset) => {
      const currentIndex = tabs.indexOf(currentTab);

      if (currentIndex === -1) {
        return;
      }

      const nextIndex = (currentIndex + offset + tabs.length) % tabs.length;
      const nextTab = tabs[nextIndex];

      if (!nextTab) {
        return;
      }

      activateTab(nextTab.dataset.tabTarget);
      nextTab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.tabTarget);
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          focusTabByOffset(tab, 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          focusTabByOffset(tab, -1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          activateTab(tabs[0].dataset.tabTarget);
          tabs[0].focus();
        } else if (event.key === 'End') {
          event.preventDefault();
          const lastTab = tabs[tabs.length - 1];
          activateTab(lastTab.dataset.tabTarget);
          lastTab.focus();
        }
      });
    });

    // 只为接近视口或有切换意图的区块预取；Save-Data 下保留实际切换时的请求。
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const needsPanelFetch = (panel) =>
      panel.dataset.tabLoaded !== 'true' && !panel.querySelector(':scope > template[data-tab-panel-template]');
    if (panels.some(needsPanelFetch) && !connection?.saveData) {
      const prefetchPanels = () => {
        if (sectionRoot.isConnected && !connection?.saveData) {
          fetchAllPanels();
        }
      };

      if ('IntersectionObserver' in window) {
        panelsPrefetchObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            prefetchPanels();
          }
        }, { rootMargin: '600px 0px' }); // 与 theme-carousel 的提前加载距离一致。
        panelsPrefetchObserver.observe(sectionRoot);
        document.addEventListener('shopify:section:unload', onSectionUnload);
      }

      tabs.forEach((tab) => {
        const prefetchTab = () => {
          const panel = panels.find((item) => item.dataset.tabPanel === tab.dataset.tabTarget);
          if (panel && needsPanelFetch(panel)) {
            prefetchPanels();
          }
        };
        tab.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') {
            prefetchTab();
          }
        });
        tab.addEventListener('focus', prefetchTab);
      });
    }

    if (tabs[0]) {
      tabs.forEach((tab, index) => {
        tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      });
    }

    sliderReady.then(() => {
      if (!tabs[0]) {
        return;
      }

      scrollTabIntoView(tabs[0]);

      const firstPanel = sectionRoot.querySelector('[data-tab-panel]:not([hidden]) .collections-with-tabs__slider');
      if (firstPanel && typeof firstPanel.activate === 'function') {
        firstPanel.activate({ reset: true });
      }
    });
  }

  function mountCollectionsWithTabs(root) {
    if (root.matches?.('[data-collections-with-tabs-id]')) initCollectionsWithTabs(root);
    root.querySelectorAll?.('[data-collections-with-tabs-id]').forEach(initCollectionsWithTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountCollectionsWithTabs(document), { once: true });
  } else {
    mountCollectionsWithTabs(document);
  }
  document.addEventListener('shopify:section:load', (event) => mountCollectionsWithTabs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid-content"] && !Shopify.designMode) return;
  try {
    
  function initGalleryGridContent(sectionRoot) {
    const gallerySection = sectionRoot.querySelector('[data-gallery-category]');

    if (!gallerySection || gallerySection.dataset.galleryFilterBound === 'true') return;

    gallerySection.dataset.galleryFilterBound = 'true';
    const globalEvents = new AbortController();
    let videoObserver = null;

    const loadGalleryVideo = (video) => {
      if (video.dataset.loaded !== 'true') {
        video.dataset.loaded = 'true';
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
      }
      video.play().catch(() => {});
    };

    const galleryVideos = gallerySection.querySelectorAll('.sec__gallery-video');
    if ('IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !gallerySection.hidden) {
            loadGalleryVideo(entry.target);
          } else {
            entry.target.pause();
          }
        });
      }, { rootMargin: '700px 0px' });
      galleryVideos.forEach((video) => videoObserver.observe(video));
    } else {
      galleryVideos.forEach(loadGalleryVideo);
    }

    const updateGallerySection = (filter) => {
      if (!filter) return;
      gallerySection.hidden = gallerySection.dataset.galleryCategory !== filter;
      if (gallerySection.hidden) {
        galleryVideos.forEach((video) => video.pause());
      } else if (!videoObserver) {
        galleryVideos.forEach(loadGalleryVideo);
      }
    };

    document.addEventListener('gallery-filter:change', (event) => {
      updateGallerySection(event.detail?.filter);
    }, { signal: globalEvents.signal });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== sectionRoot && !sectionRoot.contains(event.target)) return;
      globalEvents.abort();
      videoObserver?.disconnect();
      galleryVideos.forEach((video) => video.pause());
      gallerySection.dataset.galleryFilterBound = 'false';
    }, { signal: globalEvents.signal });

    const activeTab = document.querySelector(
      '[data-gallery-tabs] [data-gallery-filter].is-active'
    );

    if (activeTab) {
      updateGallerySection(activeTab.dataset.galleryFilter);
    }
  }

  function mountGalleryGridContent(root) {
    if (root.matches?.('[data-gallery-category]')) initGalleryGridContent(root.parentElement || root);
    root.querySelectorAll?.('[data-gallery-category]').forEach((section) => {
      initGalleryGridContent(section.closest('.shopify-section') || section.parentElement);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountGalleryGridContent(document), { once: true });
  } else {
    mountGalleryGridContent(document);
  }
  document.addEventListener('shopify:section:load', (event) => mountGalleryGridContent(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-tabs"] && !Shopify.designMode) return;
  try {
    
function mountGalleryTabs() {
    const tabsContainers = document.querySelectorAll(
      '[data-gallery-tabs]:not([data-gallery-tabs-bound])'
    );

    tabsContainers.forEach((container) => {
      container.dataset.galleryTabsBound = 'true';

      const scrollContainer = container.querySelector(
        '.gallery-tabs__scroll'
      );

      const buttons = Array.from(
        container.querySelectorAll('[data-gallery-filter]')
      );

      const activateFilter = (selectedButton) => {
        buttons.forEach((button) => {
          const active = button === selectedButton;

          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (window.matchMedia('(max-width: 767px)').matches) {
          const targetLeft =
            selectedButton.offsetLeft -
            (scrollContainer.clientWidth - selectedButton.offsetWidth) / 2;

          scrollContainer.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
        }

        container.dispatchEvent(
          new CustomEvent('gallery-filter:change', {
            bubbles: true,
            detail: {
              filter: selectedButton.dataset.galleryFilter
            }
          })
        );
      };

      // Mouse drag-to-scroll (desktop only)
      let hasDragged = false;

      if (!('ontouchstart' in window)) {
        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        scrollContainer.addEventListener('mousedown', (e) => {
          isDragging = true;
          hasDragged = false;
          startX = e.pageX - scrollContainer.offsetLeft;
          scrollLeft = scrollContainer.scrollLeft;
        });

        scrollContainer.addEventListener('mouseleave', () => {
          isDragging = false;
          hasDragged = false;
          scrollContainer.classList.remove('is-dragging');
        });

        scrollContainer.addEventListener('mouseup', () => {
          isDragging = false;
          scrollContainer.classList.remove('is-dragging');
        });

        scrollContainer.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          const x = e.pageX - scrollContainer.offsetLeft;
          const walk = x - startX;
          if (Math.abs(walk) > 3) {
            if (!hasDragged) scrollContainer.classList.add('is-dragging');
            hasDragged = true;
            e.preventDefault();
          }
          scrollContainer.scrollLeft = scrollLeft - walk;
        });
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (hasDragged) return;
          activateFilter(button);
        });
      });
    });
  }

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountGalleryTabs, { once: true });
} else {
  mountGalleryTabs();
}
document.addEventListener('shopify:section:load', mountGalleryTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  // Local controller: reuse the header's server-rendered results without its global IDs/listeners.
  if (!customElements.get('search-page-suggestions')) {
    customElements.define('search-page-suggestions', class extends HTMLElement {
      connectedCallback() {
        // Legacy mixed-result URLs must start a new product query, not filter a paginated array.
        if (this.dataset.normalizeType === 'true') {
          const url = new URL(location.href);
          url.searchParams.set('type', 'product');
          url.searchParams.delete('page');
          url.searchParams.delete('options[fields]');
          location.replace(url.href);
          return;
        }
        this.input = this.querySelector('input[name="q"]');
        this.panel = this.querySelector('[role="listbox"]');
        this.status = this.querySelector('[data-search-page-status]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.input.addEventListener('input', () => {
          this.close();
          this.timer = setTimeout(() => this.load(), 250);
        }, options);
        this.input.addEventListener('focus', () => this.load(), options);
        this.input.addEventListener('click', () => {
          if (this.panel.hidden && !this.panel.hasAttribute('aria-busy')) this.load();
        }, options);
        this.querySelector('[data-search-page-clear]').addEventListener('click', () => {
          this.input.value = '';
          this.close();
          this.input.focus();
        }, options);
        this.addEventListener('keydown', (event) => this.onKey(event), options);
        // The legacy header listens to keyup on document; keep the two inputs independent.
        this.addEventListener('keyup', (event) => event.stopPropagation(), options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.blurTimer);
          this.blurTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0);
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
      }
      disconnectedCallback() {
        if (!this.events) return;
        this.close();
        clearTimeout(this.blurTimer);
        this.events.abort();
      }
      close() {
        clearTimeout(this.timer);
        this.request?.abort();
        this.panel.hidden = true;
        this.panel.removeAttribute('aria-busy');
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.panel.querySelectorAll('[aria-selected]').forEach((item) => item.setAttribute('aria-selected', 'false'));
        this.status.textContent = '';
      }
      async load() {
        const term = this.input.value.trim();
        if (!term || document.activeElement !== this.input) return;
        this.request?.abort();
        const request = this.request = new AbortController();
        const url = new URL(this.dataset.predictiveUrl, location.origin);
        url.search = new URLSearchParams({ q: term, 'resources[type]': 'product,page,article',
          'resources[limit]': '4', 'resources[limit_scope]': 'each',
          'resources[options][prefix]': 'last', 'resources[options][unavailable_products]': 'last',
          section_id: 'predictive-search-results' }).toString();
        this.panel.setAttribute('aria-busy', 'true');
        this.status.textContent = 'Searching…';
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (request.signal.aborted || this.input.value.trim() !== term || document.activeElement !== this.input) return;
          const groups = [...parsed.querySelectorAll('.search-drawer-recently')];
          const content = document.createDocumentFragment();
          parsed.querySelectorAll('style[data-section-stylesheet]').forEach((style) => content.append(style));
          groups.forEach((group, index) => {
            // Remove header IDs, then assign scoped IDs to headings and options.
            group.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
            group.querySelectorAll('[role], [aria-selected], [aria-labelledby]').forEach((node) => {
              node.removeAttribute('role'); node.removeAttribute('aria-selected'); node.removeAttribute('aria-labelledby');
            });
            const heading = group.querySelector('.search-drawer-title');
            heading.id = `${this.panel.id}-group-${index}`;
            group.setAttribute('role', 'group');
            group.setAttribute('aria-labelledby', heading.id);
            // Keep page-only styles separate from classes owned by the header section.
            const classes = {
              'search-drawer-section': 'group', 'search-drawer-title': 'group-title',
              'site-header__predictive-products-grid': 'grid', 'site-header__recent-card-slide': 'item',
              'site-header__recent-card-figure': 'figure', 'site-header__recent-card-media': 'media',
              'site-header__recent-card-title': 'title',
              'site-header__predictive-secondary-results': 'secondary-results'
            };
            Object.entries(classes).forEach(([source, target]) => {
              const nodes = [...group.querySelectorAll(`.${source}`)];
              if (group.classList.contains(source)) nodes.push(group);
              nodes.forEach((node) => node.classList.replace(source, `search-page__suggestion-${target}`));
            });
            content.append(group);
          });
          this.panel.replaceChildren(content);
          if (!groups.length) this.addViewAll(term, 'No suggestions. Search products');
          this.status.textContent = groups.length ? 'Search suggestions available.' : 'No suggestions found.';
          this.open();
        } catch (error) {
          if (request.signal.aborted) return;
          this.panel.replaceChildren();
          this.addViewAll(term, 'Search products');
          this.status.textContent = 'Suggestions unavailable. You can still search all results.';
          this.open();
        } finally {
          if (this.request === request) this.panel.removeAttribute('aria-busy');
        }
      }
      addViewAll(term, label) {
        const link = document.createElement('a');
        const url = new URL(this.querySelector('form').action);
        url.search = new URLSearchParams({ q: term, type: 'product', 'options[prefix]': 'last', 'options[unavailable_products]': 'last' }).toString();
        link.href = url;
        link.className = 'search-page__view-all';
        link.textContent = label;
        this.panel.append(link);
      }
      open() {
        this.panel.querySelectorAll('a[href]').forEach((link, index) => {
          link.id = `${this.panel.id}-option-${index}`;
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
        });
        this.panel.hidden = false;
        this.panel.scrollTop = 0;
        this.input.setAttribute('aria-expanded', 'true');
      }
      onKey(event) {
        if (event.key === 'Escape') { this.close(); return; }
        if (this.panel.hidden || event.target !== this.input) return;
        const links = [...this.panel.querySelectorAll('a[href]')];
        const current = links.findIndex((link) => link.id === this.input.getAttribute('aria-activedescendant'));
        if (event.key === 'Enter' && current >= 0) {
          event.preventDefault(); links[current].click();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!links.length) return;
          const next = current < 0
            ? (event.key === 'ArrowDown' ? 0 : links.length - 1)
            : (current + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links.forEach((link, index) => link.setAttribute('aria-selected', String(index === next)));
          this.input.setAttribute('aria-activedescendant', links[next].id);
          links[next].scrollIntoView({ block: 'nearest' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faqs"]) return;
  try {
    
  if (!customElements.get('faq-page')) {
    customElements.define('faq-page', class extends HTMLElement {
      connectedCallback() {
        this.stopAnimations();
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.input = this.querySelector('[data-faq-input]');
        this.form = this.querySelector('[data-faq-search]');
        if (!this.input || !this.form) return;
        this.clearButton = this.querySelector('[data-faq-clear]');
        this.status = this.querySelector('[data-faq-status]');
        this.noResults = this.querySelector('[data-faq-no-results]');
        this.topics = this.querySelector('[data-faq-topics]');
        this.groups = [...this.querySelectorAll('[data-faq-group]')];
        this.items = [...this.querySelectorAll('[data-faq-item]')].map((element) => ({ element, text: this.normalize(element.textContent) }));
        this.searching = false;
        this.savedOpen = new Map();
        this.animatingItems = new Set();
        this.addEventListener('click', (event) => this.toggleItem(event), { signal });
        this.input.addEventListener('input', (event) => {
          if (!event.isComposing) this.filter();
        }, { signal });
        this.input.addEventListener('compositionend', () => this.filter(), { signal });
        this.topics?.addEventListener('click', (event) => {
          if (!event.target.closest('a[href^="#"]')) return;
          // Measure the current sticky header before native anchor scrolling.
          const header = document.querySelector('.section-site-header');
          this.style.setProperty('--faq-anchor-offset', `${header?.getBoundingClientRect().height || 0}px`);
        }, { signal });
        this.form.addEventListener('submit', (event) => { event.preventDefault(); this.filter(); }, { signal });
        this.clearButton.addEventListener('click', () => {
          this.input.value = '';
          this.filter();
          this.input.focus();
        }, { signal });
        this.filter();
        this.form.hidden = false;
      }
      disconnectedCallback() {
        this.stopAnimations();
        this.controller?.abort();
      }
      toggleItem(event) {
        const summary = event.target.closest('summary.faq-page__question');
        if (!summary || summary.closest('faq-page') !== this || event.defaultPrevented) return;
        const item = summary.parentElement;
        const answer = item.querySelector('[data-faq-answer]');
        if (typeof slideAnime !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.stopAnimations();
          answer.style.display = '';
          return;
        }
        event.preventDefault();
        if (this.animatingItems.has(item)) return;
        const opening = !item.open;
        if (opening) {
          answer.style.display = 'none';
          item.open = true;
        }
        // Reuse theme.js motion; keep details open until its closing slide completes.
        const started = slideAnime({
          target: answer,
          animeType: opening ? 'slideDown' : 'slideUp',
          addFunction: () => {
            item.open = opening;
            item.classList.remove('is-closing');
            this.animatingItems.delete(item);
          },
        });
        if (started === false) {
          item.open = opening;
          answer.style.display = '';
          return;
        }
        item.classList.toggle('is-closing', !opening);
        this.animatingItems.add(item);
      }
      stopAnimations() {
        this.animatingItems?.forEach((item) => {
          const answer = item.querySelector('[data-faq-answer]');
          answer.getAnimations().forEach((animation) => animation.cancel());
          item.open = !item.classList.contains('is-closing');
          item.classList.remove('is-closing');
          answer.style.display = '';
        });
        this.animatingItems?.clear();
      }
      normalize(value) {
        return value.normalize('NFKD').replace(/\p{M}/gu, '').replace(/[‘’]/g, "'").toLowerCase().replace(/\s+/g, ' ').trim();
      }
      filter() {
        this.stopAnimations();
        const query = this.normalize(this.input.value);
        const terms = query ? query.split(' ') : [];
        if (query && !this.searching) {
          this.savedOpen = new Map(this.items.map(({ element }) => [element, element.open]));
        }
        let count = 0;
        this.items.forEach(({ element, text }) => {
          const matches = terms.every((term) => text.includes(term));
          element.hidden = !matches;
          element.querySelector('[data-faq-answer]').style.display = '';
          if (query) element.open = matches;
          else if (this.searching) element.open = this.savedOpen.get(element) || false;
          if (matches) count += 1;
        });
        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
        });
        this.clearButton.hidden = this.input.value.length === 0;
        this.noResults.hidden = count > 0;
        if (this.topics) this.topics.hidden = Boolean(query);
        this.status.textContent = count === 1 ? this.status.dataset.resultOne : this.status.dataset.resultMany.replace('[count]', String(count));
        this.searching = Boolean(query);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
